// https://vuex.vuejs.org/en/getters.html

export default {
  db: state => {
    return state.db;
  },
  st: state => {
    return state.st;
  },
  getRoutes: state => {
    return state.routeList;
  },
  getConfig: state => {
    return state.config;
  }
};
